import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

const InputSelecter = ({ label, name, options, value, onChange }) => {
  const isLabel = !!label;
  return (
    <div>
      {/* Label above the select */}
      {isLabel && (
        <span className="mb-1 text-base font-medium text-gray-700 block">
          {label}<span className="text-[14px] text-[#E72848]">*</span>
        </span>
      )}
      <FormControl fullWidth size="small">
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          renderValue={
            value !== ""
              ? undefined
              : () => <span>{`${isLabel ? "Select" : "Sort By"}`}</span>
          }
          sx={{
            background: "#FFF",
            border: "1px solid #D5D7DA",
            borderRadius: "0.75rem",
            boxShadow: "0px 1px 2px 0px #0A0D120D",
            transition: "all 0.2s ease",
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&.Mui-focused": {
              boxShadow: "0 0 0 1px #E72848",
            },
            "&:hover": {
              boxShadow: "0 0 0 1px #E72848",
              borderColor: "transparent" // Optional: removes double border if needed
            }
          }}
        >
          <MenuItem value="" disabled>
            <em>{`${isLabel ? "Select" : "Sort By"}`}</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default InputSelecter;
